/* KIS sokkenkaart: bundel- en maat-pop-up + toevoegen aan winkelwagen (2026-10-02).
   Kaart = snippets/kis-socks-card.liquid. Bundelkeuze 1/2/3 packs met dezelfde korting als de sokken-productpagina
   (automatische kortingen "Bundle 2/3 (Sokken)" op collectie nike-everyday-sokken: 16% / 17%; percentages komen uit
   data-kis-socks "tiers"). Eén luisteraar op document, zodat het ook werkt na AJAX-herladen van het raster. */
(function () {
  if (window.KIS_SOCKS_INIT) return;
  window.KIS_SOCKS_INIT = true;

  var modal = null;
  var lastTrigger = null;
  var state = { data: null, tier: 2, sizes: [], busy: false };

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function calc(n) {
    var pct = (state.data.tiers && state.data.tiers[n - 1]) || 0;
    var full = state.data.cents * n;
    var save = Math.round(full * pct / 100);
    return { full: full, save: save, total: full - save, pct: pct };
  }

  function build() {
    modal = document.createElement('div');
    modal.className = 'kis-size-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'kis-size-modal-title');
    modal.innerHTML =
      '<div class="kis-size-modal__panel">' +
      '<div class="kis-size-modal__top">' +
      '<div class="kis-size-modal__thumb"><img alt="" data-kis-thumb></div>' +
      '<div><div class="kis-size-modal__name" id="kis-size-modal-title" data-kis-name></div>' +
      '<div class="kis-size-modal__price" data-kis-price></div></div>' +
      '<button type="button" class="kis-size-modal__close" aria-label="Sluiten" data-kis-close>&times;</button>' +
      '</div>' +
      '<p class="kis-size-modal__label">Kies je bundel</p>' +
      '<div class="kis-size-modal__tiers" role="radiogroup" aria-label="Bundel" data-kis-tiers></div>' +
      '<p class="kis-size-modal__label">Kies je maat</p>' +
      '<div class="kis-size-modal__packs" data-kis-packs></div>' +
      '<button type="button" class="kis-size-modal__atc" aria-disabled="true" data-kis-atc>Toevoegen aan winkelwagen</button>' +
      '<p class="kis-size-modal__msg" role="status" data-kis-msg></p>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-kis-close]')) { close(); return; }
      var t = e.target.closest('[data-kis-tier]');
      if (t) { setTier(Number(t.getAttribute('data-kis-tier'))); return; }
      var s = e.target.closest('[data-kis-size]');
      if (s && !s.disabled) { pickSize(Number(s.getAttribute('data-kis-pack')), s.getAttribute('data-kis-size')); return; }
      if (e.target.closest('[data-kis-atc]')) add();
    });

    document.addEventListener('keydown', function (e) {
      if (!modal || !modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = modal.querySelectorAll('button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function renderTiers() {
    var labels = ['', 'Populair', 'Beste deal'];
    var html = '';
    for (var n = 1; n <= 3; n++) {
      var c = calc(n);
      var active = n === state.tier;
      html += '<button type="button" class="kis-size-modal__tier' + (active ? ' is-active' : '') + '" role="radio" aria-checked="' + active + '" data-kis-tier="' + n + '">' +
        (labels[n - 1] ? '<span class="kis-size-modal__tag' + (n === 3 ? ' kis-size-modal__tag--best' : '') + '">' + labels[n - 1] + '</span>' : '') +
        '<span class="kis-size-modal__tier-main"><b>' + n + ' ' + (n === 1 ? 'pack' : 'packs') + '</b>' +
        '<small>' + (c.save > 0 ? 'Bespaar ' + money(c.save) : 'Geen bundelkorting') + '</small></span>' +
        '<span class="kis-size-modal__tier-price"><b>' + money(c.total) + '</b>' + (c.save > 0 ? '<s>' + money(c.full) + '</s>' : '') + '</span>' +
        '</button>';
    }
    modal.querySelector('[data-kis-tiers]').innerHTML = html;
  }

  function renderPacks() {
    var html = '';
    for (var i = 0; i < state.tier; i++) {
      html += '<div class="kis-size-modal__pack">' +
        (state.tier > 1 ? '<span class="kis-size-modal__pack-label">Pack ' + (i + 1) + '</span>' : '') +
        '<div class="kis-size-modal__sizes" role="group" aria-label="Maat pack ' + (i + 1) + '">';
      (state.data.variants || []).forEach(function (v) {
        var on = String(state.sizes[i]) === String(v.id);
        html += '<button type="button" class="kis-size-modal__size' + (on ? ' is-active' : '') + '" aria-pressed="' + on + '" data-kis-pack="' + i + '" data-kis-size="' + esc(v.id) + '"' +
          (v.available ? '' : ' disabled aria-label="' + esc(v.title) + ' uitverkocht"') + '>' + esc(v.title) + '</button>';
      });
      html += '</div></div>';
    }
    modal.querySelector('[data-kis-packs]').innerHTML = html;
  }

  function renderSummary() {
    var c = calc(state.tier);
    modal.querySelector('[data-kis-price]').innerHTML = money(c.total) + (c.save > 0 ? ' <s>' + money(c.full) + '</s>' : '');
    var ready = state.sizes.slice(0, state.tier).filter(Boolean).length === state.tier;
    modal.querySelector('[data-kis-atc]').setAttribute('aria-disabled', ready ? 'false' : 'true');
    modal.querySelector('[data-kis-atc]').textContent = 'Toevoegen aan winkelwagen · ' + money(c.total);
  }

  function setTier(n) {
    state.tier = n;
    var firstSize = state.sizes.filter(Boolean)[0];
    for (var i = 0; i < n; i++) if (!state.sizes[i] && firstSize) state.sizes[i] = firstSize;
    renderTiers();
    renderPacks();
    renderSummary();
    modal.querySelector('[data-kis-msg]').textContent = '';
  }

  function pickSize(pack, id) {
    var wasEmpty = !state.sizes.filter(Boolean).length;
    state.sizes[pack] = id;
    if (wasEmpty) {
      for (var i = 0; i < state.tier; i++) if (!state.sizes[i]) state.sizes[i] = id;
    }
    renderPacks();
    renderSummary();
    modal.querySelector('[data-kis-msg]').textContent = '';
  }

  function open(card, trigger) {
    var data;
    try { data = JSON.parse(card.getAttribute('data-kis-socks')); } catch (err) { return; }
    if (!modal) build();
    lastTrigger = trigger || null;
    state.data = data;
    state.tier = Number(data.defaultTier) || 2;
    state.sizes = [];
    modal.querySelector('[data-kis-thumb]').src = data.img || '';
    modal.querySelector('[data-kis-name]').textContent = data.title || '';
    modal.querySelector('[data-kis-msg]').textContent = '';
    renderTiers();
    renderPacks();
    renderSummary();
    modal.classList.add('is-open');
    document.documentElement.classList.add('kis-modal-open');
    var active = modal.querySelector('[data-kis-tier].is-active');
    (active || modal.querySelector('[data-kis-close]')).focus();
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('kis-modal-open');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  function add() {
    var msg = modal.querySelector('[data-kis-msg]');
    var atc = modal.querySelector('[data-kis-atc]');
    var chosen = state.sizes.slice(0, state.tier);
    if (chosen.filter(Boolean).length < state.tier) {
      msg.textContent = state.tier > 1 ? 'Kies een maat voor elke pack.' : 'Kies eerst je maat.';
      return;
    }
    if (state.busy) return;
    state.busy = true;
    atc.textContent = 'Bezig met toevoegen...';

    var qty = {};
    chosen.forEach(function (id) { qty[id] = (qty[id] || 0) + 1; });
    var items = Object.keys(qty).map(function (id) { return { id: Number(id), quantity: qty[id] }; });

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        close();
        try {
          if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { source: 'kis-socks-card' });
          }
        } catch (err) {}
        var drawer = document.querySelector('m-cart-drawer');
        var drawerOn = !window.MinimogSettings || window.MinimogSettings.enable_cart_drawer !== false;
        if (/\/cart(\/|$|\?)/.test(location.pathname)) {
          location.reload();
        } else if (drawer && drawerOn && typeof drawer.open === 'function') {
          if (typeof drawer.onCartDrawerUpdate === 'function') drawer.onCartDrawerUpdate();
          drawer.open(lastTrigger);
        } else {
          location.href = '/cart';
        }
      })
      .catch(function () {
        msg.textContent = 'Toevoegen lukte niet, probeer het opnieuw.';
      })
      .then(function () {
        state.busy = false;
        if (modal.classList.contains('is-open')) renderSummary();
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-kis-socks-open]');
    if (!trigger) return;
    var card = trigger.closest('[data-kis-socks]');
    if (!card) return;
    e.preventDefault();
    e.stopPropagation();
    open(card, trigger);
  });
})();
